window.bar = function bar() {
  return new Promise(resolve => setTimeout(resolve, 100))
}



// WEBPACK FOOTER //
// ./original.js